<template>
  <section
    class="hero hero-home"
    :style="`background-image: url(${homeHeaderImage})`"
  >
    <div class="container">
      <div class="hero-content">
        <h1 class="black">
          Eat the
          <u>best</u> grass-fed meat
        </h1>
        <PostcodeSearch />
      </div>
    </div>
  </section>
</template>

<script>
import HomeHeaderImage from "../../src/assets/images/graphic-node-mFhGB09LXWo-unsplash-min.png";
import PostcodeSearch from "../../components/content/PostcodeSearch";

export default {
  name: "Hero",
  components: {
    PostcodeSearch
  },
  computed: {
    homeHeaderImage() {
      return HomeHeaderImage;
    }
  }
};
</script>

<style lang="scss">
@import "@/global-styles/variables.scss";

.hero {
  background-color: $black;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: $white;
  min-height: 150px;
  overflow: hidden;
  padding: $spacing-9 0;
  position: relative;
  text-align: left;
  width: 100%;

  img {
    margin: auto;
  }

  .hero-img {
    max-width: 50%;
    position: absolute;
    right: 0;
    top: 100px;
    transform: scaleX(-1) rotate(270deg);

    &:last-of-type {
      right: 20%;
    }
  }

  h1 {
    margin-bottom: $spacing-4;
    margin-top: $spacing-2;
    text-shadow: $box-shadow;
  }

  @media only screen and (max-width: $large-bp) {
    .hero-img {
      max-width: 50%;
      right: -50px;
      top: 105px;

      &:last-of-type {
        right: 10%;
      }
    }
  }

  @media only screen and (max-width: $small-bp - 1px) {
    padding: $spacing-5 0;
    text-align: center;

    .hero-img {
      max-width: 80%;
      right: -30px;
      top: 470px;

      &:last-of-type {
        left: -120px;
      }
    }
  }
}

.hero-home {
  background-position: right bottom;
  background-size: contain;
  height: 500px;
  background-size: 90%;
  background-color: $red-2;
  text-align: left;

  .postcode-search {
    margin: 0 auto;
  }

  .hero-content {
    max-width: 440px;
    margin: 0;
  }

  h1 {
    text-shadow: none;
    font-size: 2.4em;
  }

  @media only screen and (min-width: $small-bp) {
    h1 {
      font-size: 3.4em;
    }

    .hero-content {
      max-width: 500px;
    }
  }

  @media only screen and (min-width: $large-bp) {
    background-size: 1000px;
    height: 450px;
  }
}
</style>
